import CourseListCoursesByJobTitle from './Request/Course_listCoursesByJobTitle';
import graphql from './graphql';
import minutesToHour from '../Utils/MinutesToHours';
import courseSetJobTitleType from './Request/Course_SetJobTitleType';

/**
 * Un curso tal como lo pinta la pantalla de definición: la duración ya legible
 * y las terminales como lista, para que la tabla las una y el filtro las
 * compare una por una.
 */
const mapCourseList = courses =>
  (courses || []).map(course => ({
    id: course?.id,
    name: course?.name || '',
    duration: minutesToHour(course?.duration),
    categoryName: course?.CourseCategory?.name || 'sin categoría',
    terminalNames: (course?.Enterprise?.Terminals || []).map(terminal => terminal.name),
    isChecked: Boolean(course?.isChecked),
  }));

const mapNames = rows => (rows || []).map(row => row.name || '');

const fetch = async (departmentId, jobTitleId) => {
  const response = await Promise.all([
    CourseListCoursesByJobTitle(departmentId, jobTitleId),
    graphql('CourseCategory_list', 'name', 'query'),
    graphql('Terminal_list', 'name', 'query'),
  ]);

  return {
    courseByEnterprise: mapCourseList(response[0].EnterpriseCourses),
    courseByDepartment: mapCourseList(response[0].DepartmentCourses),
    courseByJobTitle: mapCourseList(response[0].JobTitleCourses),
    categories: mapNames(response[1].CourseCategory_list),
    terminals: mapNames(response[2].Terminal_list),
  };
};

export default fetch;

export const update = async (coursesData, jobTitleId) => courseSetJobTitleType(coursesData, jobTitleId);
